import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Badge, Card, type CardProps } from "@/components/ui";
import { cn } from "@/lib/utils";

export function SectionModifiedBadge({ className }: { className?: string }) {
  const { t } = useTranslation("common");

  return (
    <Badge variant="warning" size="sm" className={className} aria-live="polite">
      {t("sectionModified")}
    </Badge>
  );
}

interface ModifiedSectionCardProps extends CardProps {
  modified?: boolean;
  children: ReactNode;
}

export function ModifiedSectionCard({
  modified = false,
  className,
  children,
  ...props
}: ModifiedSectionCardProps) {
  return (
    <Card
      className={cn(
        "relative",
        modified && "border-warning-400 ring-2 ring-warning-100",
        className,
      )}
      {...props}
    >
      {modified ? (
        <SectionModifiedBadge className="absolute right-4 top-4 z-10" />
      ) : null}
      {children}
    </Card>
  );
}
